import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { Typography } from "@insite/mobius/index";
import Link from "@insite/mobius/Link";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import ProductPrice, { ProductPriceStyles } from "@tsesco/Overrides/Components/ProductPrice";
import * as React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

type OwnProps = WidgetProps & HasProductContext & ReturnType<typeof mapStateToProps>;

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

export interface ProductDetailsPriceStyles {
    productPrice?: ProductPriceStyles;
    callForPricing?: InjectableCss;
    priceWrapper?: InjectableCss;
    multipleSaleQtyStyle?: InjectableCss;
}

export const priceStyles: ProductDetailsPriceStyles = {
    productPrice: {
        price: {
            priceText: {
                size: 26,
                css: css`
                    font-size: 30px !important;
                    font-family: "Roboto-Regular";
                    font-weight: 700;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            null,
                            css`
                                font-size: 19px !important;
                            `,
                            null,
                        ])}
                `,
            },
            unitOfMeasure: {
                unitOfMeasureText: {
                    size: 18,
                    css: css`
                        font-size: 18px !important;
                        font-family: "Roboto-Regular";
                        ${({ theme }: { theme: BaseTheme }) =>
                            breakpointMediaQueries(theme, [
                                null,
                                null,
                                null,
                                css`
                                    font-size: 18px !important;
                                `,
                                null,
                            ])}
                    `,
                },
            },
        },
        packWrapper: {
            css: css`
                /* margin-bottom: 8px; */
                span {
                    font-size: 30px !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            null,
                            null,
                            null,
                            css`
                                font-size: 19px !important;
                            `,
                            null,
                        ])}
                }
            `,
        },
    },

    callForPricing: {
        css: css`
            padding-left: 15px;
            padding-top: 15px;
            span {
                font-size: 18px;
                font-family: "Roboto-Bold";
            }
        `,
    },
    priceWrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            line-height: 33px;
            padding-top: 10px;
            > section {
                // padding: 20px 2px 0px 15px !important;
                padding-right: 4px;
            }
            > span {
                // padding: 30px 0px 0px 2px;
                font-size: 15px;
                font-weight: 600;
                display: flex;
                align-items: flex-start;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            line-height: 2;
                        `,
                        css`
                            line-height: 2;
                        `,
                        css`
                            line-height: 2;
                        `,
                        css`
                            font-size: 13px !important;
                        `,
                        null,
                    ])}
            }
        `,
    },
    multipleSaleQtyStyle:{
        css: css`
            color: #000000;
            white-space: nowrap;
            font-size: 18px !important;
            font-family: 'Roboto-Regular';
            padding-top: 4px;
            font-weight: 500 !important;
        `,
    }
};

const styles = priceStyles;

const ProductDetailsPrice: React.FC<OwnProps> = ({ productContext, productSettings }) => {
    let multipleSaleQty;
    if (productContext?.product?.unitOfMeasures?.length && productContext?.product?.unitOfMeasures?.length > 1) {
        const productSale = productContext.product.unitOfMeasures?.filter(
            o => o.unitOfMeasure === productContext.productInfo.unitOfMeasure,
        );
        if (productSale[0].unitOfMeasure === "EA") {
            multipleSaleQty = productContext.product.detail?.multipleSaleQty;
        }
        else if(productSale[0].unitOfMeasure === "FT"){
            multipleSaleQty = productContext?.product?.detail?.multipleSaleQty;
        } 
        else {
            multipleSaleQty = productSale[0].qtyPerBaseUnitOfMeasure;
        }
        // multipleSaleQty = productSale[0].qtyPerBaseUnitOfMeasure;
    } else {
        multipleSaleQty = productContext.product.detail?.multipleSaleQty;
    }
    return (
        <>
            {productContext.product.properties?.isCallForPricing?.toLowerCase() === "true" ? (
                <Link href="/request-quote" {...styles.callForPricing}>
                    {translate("Call for Pricing")}
                </Link>
            ) : (
                <StyledWrapper {...styles.priceWrapper}>
                    <ProductPrice
                        product={productContext}
                        showLabel={false}
                        showSavings={true}
                        showSavingsAmount={productSettings.showSavingsAmount}
                        showSavingsPercent={productSettings.showSavingsPercent}
                        extendedStyles={styles.productPrice}
                    />
                    {productContext.productInfo?.pricing?.unitRegularPrice && multipleSaleQty && multipleSaleQty > 1 ? (
                        <Typography {...styles.multipleSaleQtyStyle}>
                            ($
                            {(productContext.productInfo?.pricing?.unitRegularPrice / multipleSaleQty).toFixed(2)} / 1)
                        </Typography>
                    ) : null}
                </StyledWrapper>
            )}
        </>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withProductContext(ProductDetailsPrice)),
    definition: {
        displayName: "Price",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
